import React, { useEffect, useState } from "react";
import Navbar from "../../Layouts/Navbar/Navbar";
import Loader from "../../Layouts/Loader/Loader";
import PageInfoAndActionBar from "../../Layouts/PageInfoAndActionBar";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { ImagePreview } from "../Screen/Header/HeaderLogoModal";
import BuilderTable from "../../Layouts/BuilderTable";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import { useModalContext } from "../../context/ModalContext";
import Input from "../../components/FormComponents/Input";
import Textarea from "../../components/FormComponents/Textarea";
import Button from "../../components/FormComponents/Button";
import HeaderModes from "../../Layouts/Navbar/HeaderModes";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { toastError, toastSuccess } from "../../utils/toastUtils";

const ImageRepoSection = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allImages, setAllImages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const { getUserConfirmationForDelete } = useModalContext();

  const getAllImages = async () => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(`/image_repo`);
      setAllImages(data);
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleDeleteImage = async (id) => {
    try {
      const userConfirmation = await getUserConfirmationForDelete("image");
      if (!userConfirmation) return;

      const { message } = axiosInstance.delete(`image_repo/${id}`);
      const filteredImages = allImages.filter((image) => image.id !== id);
      setAllImages(filteredImages);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const columns = [
    { key: "image_data.name", type: "img", header: "Image" },
    { key: "name_description", header: "Name & Description" }
  ];

  const customColumns = [
    {
      header: "Actions",
      render: (image) => (
        <>
          <ButtonActionIcon type="delete" onClick={() => handleDeleteImage(image.id)} />
        </>
      )
    }
  ];

  const mergedData = allImages.map((image) => ({
    ...image,
    name_description: (
      <div>
        <p>{image.name}</p>
        <p>{image.description}</p>
      </div>
    )
  }));

  useEffect(() => {
    getAllImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <section className="main_section">
          <>
            <div className="d_flex">
              <HeaderModes />
              <PageInfoAndActionBar pagePath={`Image Repository`} currentConfig={[]} pageName="imagerepo" />
            </div>
            <div className="d_flex">
              <Navbar />
              <div className="w_75 m_auto">
                <div className="d_flex align_center p_3">
                  <label className="builder_label">All Images</label>
                  <div className="ml_auto">
                    <Button variant="secondary" onClick={() => setIsOpen(true)}>
                      + Image
                    </Button>
                  </div>
                </div>
                <div className="img_repo_container">
                  <div style={{ width: "100%" }}>
                    <BuilderTable
                      columns={columns}
                      data={mergedData}
                      customColumns={customColumns}
                      columnStyles={{
                        Image: { width: "20px", height: "20px" },
                        "Name & Description": { width: "auto" },
                        Actions: { width: "100px", textAlign: "center" }
                      }}
                      noDataMessage="No Images Found"
                    />
                  </div>
                  <BuilderModal isOpen={isOpen} onClose={() => setIsOpen(false)} modalName="Add Image">
                    <AddImage setAllImages={setAllImages} onClose={() => setIsOpen(false)} />
                  </BuilderModal>
                </div>
              </div>
            </div>
          </>
        </section>
      )}
    </>
  );
};

const AddImage = ({ setAllImages, onClose }) => {
  const [imageData, setImageData] = useState({
    name: "",
    description: "",
    image_data: {}
  });
  //   const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImageData = (e) => {
    const { name, value } = e.target;
    setImageData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
    }
  };

  const addImage = async () => {
    if (!file || !imageData.name || !imageData.description) {
      toastError("Please fill all fields and upload an image");
      return;
    }
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("myFile", file);

      const uploadResponse = await axiosInstance.post(`/public/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      const { name, original_name, type, _id } = uploadResponse.data;
      const modifiedImage = { image_id: _id, name, original_name, type };

      const imageConfig = {
        name: imageData.name,
        description: imageData.description,
        image_data: modifiedImage
      };

      const { data, message } = await axiosInstance.post(`/image_repo`, imageConfig);

      setAllImages((prevThemes) => [...prevThemes, data]);
      toastSuccess(message);
      setImageData({ name: "", description: "", image_data: {} });
      setFile(null);
      //   setPreview(null);
      onClose();
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add_theme_container">
      <div className="builder_form">
        <Input
          label="Name"
          placeholder="Enter image name"
          value={imageData.name}
          name="name"
          onChange={handleImageData}
        />
        <Textarea label="Description" name="description" value={imageData.description} onChange={handleImageData} />
        <Input label="Upload Image" type="file" accept="image/*" onChange={handleFileChange} />
        {file && <ImagePreview file={file} />}
      </div>

      <div>
        <Button onClick={addImage} disabled={loading}>
          {loading ? "Adding..." : "Add Image"}
        </Button>
      </div>
    </div>
  );
};

export default ImageRepoSection;
